module.exports = __webpack_public_path__ + "images/home/index/values-stage-header-eb978d5991b486d6805c3788b8e5b8c2.png";